import { createFileRoute, redirect } from '@tanstack/react-router';

/** Brand styling is organization-wide; old links must not enter a branch route. */
export const Route = createFileRoute('/_authed/dashboard/brand')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/style' });
  },
});
